import React from 'react';
import IobLineItem from '../../../Domain/IobLineItem';
import IobLineItemFieldworkFees from '../../../Domain/IobLineItemFieldworkFees';
import IobLineItemOther from '../../../Domain/IobLineItemOther';
import IobLineItemTransactionAdminFees from '../../../Domain/IobLineItemTransactionAdminFees';
import ButtonRow from '../../../Elements/ButtonRow';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ErrorMessage from '../../../Elements/ErrorMessage';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import Loading from '../../../Elements/loading';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import IobLineItemService from '../../../Services/IobLineItemService';
import IobService from '../../../Services/IobService';
import EditIobLineItemWindowDescription from './EditIobLineItemWindowDescription';
import IobLineItemFieldworkFeesSearchParams from './IobLineItemFieldworkFeesSearchParams';
import IobLineItemOtherSearchParams from './IobLineItemOtherSearchParams';
import IobLineItemSearchParams from './IobLineItemSearchParams';
import IobLineItemTransactionAdminSearchParams from './IobLineItemTransactionAdminSearchParams';
import TpIobLineItemFieldworkFees from '../../../Domain/TpIobLineItemFieldworkFees';
import TpIobLineItemFieldworkFeesSearchParams from './TpIobLineItemFieldworkFeesSearchParams';
import TpIobLineItemEvaluatorSearchParams from './TpIobLineItemEvaluatorSearchParams';
import IobLineItemOutsourcedFte from '../../../Domain/IobLineItemOutsourcedFte';

export default class IobInvoiceDetailsTab extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    const urlParams = new URLSearchParams(window.location.search);

    this.state = {
      iobInvoiceId: urlParams.get('id'),
      loading: true,
      searchItem: new IobLineItemSearchParams(),
      shownPanel: ShownPanelsEnum.None,
    };

    this.dbItem = IobLineItem;
    this.searchParamsItem = IobLineItemSearchParams;

    this.showPanel = this.showPanel.bind(this);
    this.startSearch = this.startSearch.bind(this);
    this.refresh = this.refresh.bind(this);
    IobLineItem.editGeneralFunction = this.editGeneralFunction.bind(this);
    IobLineItem.getIobStatus = this.getIobStatus.bind(this);
  }

  getIobStatus() {
    return this.state.status;
  }

  setIobLineItemType(type, source) {
    switch (type) {
      case 'Translations':
      case 'Research':
      case 'Editing/Datacheck':
      case 'Misc Labor':
      case 'Other':
      case 'Adjusting Fieldwork Fees':
      case 'Adjusting Fieldwork Reimbursements':
      case 'Adjusting Evaluator Fees':
      case 'Adjusting Evaluator Reimbursements':
      case 'Voided Payments':
        this.dbItem = IobLineItemOther;
        this.searchParamsItem = IobLineItemOtherSearchParams;
        this.setState({ loading: false });
        break;
      case 'Fieldwork Fees':
        if (source && source.toString().startsWith('4')) {
          this.dbItem = TpIobLineItemFieldworkFees;
          this.searchParamsItem = TpIobLineItemFieldworkFeesSearchParams;
        } else {
          this.dbItem = IobLineItemFieldworkFees;
          this.searchParamsItem = IobLineItemFieldworkFeesSearchParams;
        }
        this.setState({ loading: false });
        break;
      case 'Evaluator Fees':
      case 'Evaluator Expenses':
        // this.dbItem = IobLineItem;
        // this.setState({ loading: false });
        // break;
        if (source && source.toString().startsWith('4')) {
          this.dbItem = TpIobLineItemFieldworkFees;
          this.searchParamsItem = TpIobLineItemEvaluatorSearchParams;
        } else {
          this.dbItem = IobLineItemFieldworkFees;
          this.searchParamsItem = IobLineItemSearchParams;
        }
        this.setState({ loading: false });
        break;
      case 'Transaction & Administrative Fees':
        this.dbItem = IobLineItemTransactionAdminFees;
        this.searchParamsItem = IobLineItemTransactionAdminSearchParams;
        this.setState({ loading: false });
        break;
      case 'Outsourced FTE':
        this.dbItem = IobLineItemOutsourcedFte;
        this.searchParamsItem = IobLineItemOtherSearchParams;
        this.setState({ loading: false });
        break;
      default:
        this.dbItem = IobLineItem;
        this.setState({ loading: false });
        break;
    }
  }

  componentDidMount() {
    IobService.GetById(this.state.iobInvoiceId)
      .then((result) => {
        this.setIobLineItemType(result.type, result.source);
        this.setState({ status: result.status, currencyName: result.currencyName, currencyId: result.currencyId });
      })
      .catch(() => ErrorMessage.SetErrorMessage('IDT76'));
  }

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.Refresh) {
      this.setState({
        searchItem: { ...this.state.searchItem },
      });
      panelId = ShownPanelsEnum.None;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  startSearch(searchItem) {
    this.setState({ searchItem });
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  editGeneralFunction(id, item) {
    this.setState({
      shownPanel: ShownPanelsEnum.Edit,
      selectedItem: item,
    });
  }

  renderButtonsAndPanels() {
    return (
      <>
        <ButtonRow
          labels={['Create']}
          colors={[ButtonColorsEnum.Primary]}
          keys={[ShownPanelsEnum.AddNewItem]}
          icons={['fa-solid fa-plus-circle']}
          roleKeys={['iob_createcreatelineitemmarkaspaidattachinvoicebutton']}
          value={this.state.shownPanel}
          onClick={this.showPanel}
        />
        {this.renderPanels()}
      </>
    );
  }

  savePanelOnClose() {
    this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem }, loading: false });
  }

  renderPanels() {
    const editedItem = new IobLineItem();
    editedItem.IobinvoiceId = this.state.iobInvoiceId;
    editedItem.CurrencyName = this.state.currencyName;
    editedItem.CurrencyId = this.state.currencyId;

    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={editedItem}
            clickOnCancel={() => this.savePanelOnClose()}
            clickOnSave={() => this.savePanelOnClose()}
            windowDescription={EditIobLineItemWindowDescription}
            errorCode='IIDT166'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.Edit,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.savePanelOnClose()}
            clickOnSave={() => this.savePanelOnClose()}
            windowDescription={EditIobLineItemWindowDescription}
            errorCode='IIDT179'
          />
        )}
      </div>
    );
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  render() {
    return this.state.loading ? (
      <Loading />
    ) : (
      <div className='contentwrapper'>
        {this.state.status === 'Draft' && this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={this.dbItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={IobLineItemService.GetListBySearching}
          convertDBItemsFunction={IobLineItemService.ConvertDBItemList}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Desc}
          orderBy={'IoblineItemId'}
          showSearchStrip={true}
          searchParamsType={this.searchParamsItem}
          clickOnStartSearch={this.startSearch}
          enableUrlPush={false}
          errorCode='IIDT207'
        />
      </div>
    );
  }
}
